import { isPositiveNumber } from "et3-type-guards";

import getCoreUIStore from "../../stores/core/core-ui-store";
import { HEADER_COMPACT_BREAKPOINT, HEADER_WIDTH } from "./header-constants";

export const getHeaderIsCompact = (windowWidth: number): boolean => {
  const screenWidth = isPositiveNumber(windowWidth)
    ? windowWidth
    : HEADER_WIDTH;

  return screenWidth < HEADER_COMPACT_BREAKPOINT;
};

export const getHeaderIsCompactFromStore = (): boolean =>
  getHeaderIsCompact(getCoreUIStore().windowWidth.get());
